import { TagsDashboardTable, TagsToolbar } from "modules/TagsDashboard/components";

export const TagsDashboard = () => (
  <>
    <TagsToolbar />
    <TagsDashboardTable />
  </>
);
